import axios from "axios";
import { makeFilterString } from "../../utils/Helper";
import { BaseURL } from "../../utils/constant";
import handleErrors from "../../utils/handel_error";

import { reduxRequest } from "../../../../common/utils/reduxRequest";
import {
  AddCategoriesSuccess,
  CategoriesLoading,
  GetCategoriesDetailsSuccess,
  GetCategoriesSuccess,
  GetScrollCategoriesTypesSuccess,
  GetScrollSubcategoriesSuccess,
} from "./Action";

export const getCategoriesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "list",
    successFunction: GetCategoriesSuccess,
    url: `/admin/categories/categories${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const GetScrollCategoriesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "list",
    successFunction: GetScrollCategoriesTypesSuccess,
    url: `/admin/categories/categories${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const GetScrollSubcategoriesRequest = ({ ...variables }) => {
  return async (dispatch) => {
    const params = { ...variables?.params };
    const parentIds = params?.parent_ids?.length
      ? params.parent_ids
      : params?.parent_id
        ? [params.parent_id]
        : [];

    delete params.parent_ids;

    if (!parentIds.length) {
      dispatch(
        GetScrollSubcategoriesSuccess({
          data: { categories: [] },
          extra: { total_count: 0, page_number: 1 },
          replace: true,
        }),
      );
      return;
    }

    if (parentIds.length === 1) {
      const requestData = {
        isLoading: CategoriesLoading,
        loadingType: "subcategories-list",
        successFunction: GetScrollSubcategoriesSuccess,
        url: `/admin/categories/categories${makeFilterString({
          ...params,
          parent_id: parentIds[0],
        })}`,
        method: "get",
      };
      return reduxRequest({
        dispatch,
        ...requestData,
      });
    }

    dispatch(
      CategoriesLoading({
        type: "subcategories-list",
        loading: true,
      }),
    );
    try {
      const responses = await Promise.all(
        parentIds.map((parent_id) =>
          axios({
            url: `/admin/categories/categories${makeFilterString({
              ...params,
              parent_id,
            })}`,
            baseURL: BaseURL,
            method: "get",
          }),
        ),
      );
      const merged = [];
      const seen = new Set();
      responses.forEach((response) => {
        (response?.data?.data?.categories || []).forEach((item) => {
          if (!seen.has(item.id)) {
            seen.add(item.id);
            merged.push(item);
          }
        });
      });
      dispatch(
        GetScrollSubcategoriesSuccess({
          data: { categories: merged },
          extra: { total_count: merged.length, page_number: 1 },
          replace: true,
        }),
      );
    } catch (error) {
      handleErrors(error);
    } finally {
      dispatch(
        CategoriesLoading({
          type: "",
          loading: false,
        }),
      );
    }
  };
};

export const createCategoriesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "add",
    successFunction: AddCategoriesSuccess,
    action: variables?.action,
    url: `/admin/categories/categories`,
    method: "post",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getCategoryDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "details",
    successFunction: variables?.skipStore
      ? undefined
      : GetCategoriesDetailsSuccess,
    action: variables?.action,
    url: `/admin/categories/categories/${variables?.category_id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deleteCategoryRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "delete category",
    action: variables?.action,
    url: `/admin/categories/categories/${variables?.id}`,
    method: "delete",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateCategoryRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "update category",
    url: `/admin/categories/categories/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const activateCategoryRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "activate category",
    action: variables?.action,
    url: `/admin/categories/categories/${variables?.id}/activate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deactivateCategoryRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CategoriesLoading,
    loadingType: "deactivate category",
    action: variables?.action,
    url: `/admin/categories/categories/${variables?.id}/deactivate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
